// extracted by mini-css-extract-plugin
export default {"social_links_wrapper":"socialLinks_social_links_wrapper__7sgF1","icon":"socialLinks_icon__Gj4gR"};